// Security hook to detect and respond to clickjacking attempts.
import { useState, useEffect } from "react";

export function useAntiClickjack() {
	const [isFramed, setIsFramed] = useState(false);

	useEffect(() => {
		// window.self !== window.top means the page is inside an iframe
		const framed = window.self !== window.top;
		setIsFramed(framed)

		if(!framed) return;

		try {
			// Attempt to break out of the frame
			window.top.location.href = window.location.href;
		} catch (error) {
			// Fallback if redirect is blocked - hide the page
			document.body.style.display = "none"
		}
		
	}, [])

	return { isFramed };
}